import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "../lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    const refresh = useCallback(async () => {
        try {
            const { data } = await api.get("/auth/me");
            setUser(data);
        } catch {
            setUser(null);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        // If returning from Emergent OAuth, skip /me check; AuthCallback will handle it
        if (typeof window !== "undefined" && window.location.hash?.includes("session_id=")) {
            setLoading(false);
            return;
        }
        refresh();
    }, [refresh]);

    const loginJwt = async (email, password) => {
        const { data } = await api.post("/auth/login", { email, password });
        localStorage.setItem("rj_token", data.token);
        setUser(data.user);
        return data.user;
    };

    const register = async (email, name, password, phone) => {
        const { data } = await api.post("/auth/register", { email, name, password, phone });
        localStorage.setItem("rj_token", data.token);
        setUser(data.user);
        return data.user;
    };

    const logout = async () => {
        try {
            await api.post("/auth/logout");
        } catch {}
        localStorage.removeItem("rj_token");
        setUser(null);
    };

    return (
        <AuthContext.Provider value={{ user, loading, loginJwt, register, logout, refresh, setUser }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
